import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';
import { useReadQueryParams, useUpdateQueryParams } from './useQueryParams';

export const useContainer = (defaultPageSize, isFetch) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [sum, setSum] = useState({ ClientDebt: 0, CompanyDebt: 0, Pwin: 0, Rwin: 0 })

  const updateQueryParams = useUpdateQueryParams();
 
  const defaultConfig = {
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1, 
    search: "",
    status_id: 0,
    is_transit: 0,
    green: 0,
    bl_search: 0,
    price_filter: 0,
    custom_filter: 0,
    created_at_min: "",
    created_at_max: "",
    entry_at_min: "",
    entry_at_max: "",
    open_at_min: "",
    open_at_max: "",
    taken_at_min: "",
    taken_at_max: "",
    shipper_id: 0,
    marine_line_id: 0,
    is_deleted: false,
    is_archive: false,
  }
 
  const [filter, setFilter] = useState(useReadQueryParams(defaultConfig));

  useEffect(() => {
    if (defaultPageSize > 0) {
      fetchList();
      listSum();
    }
  }, [filter]);

  const fetchList = async () => {
    try {
      updateQueryParams(filter);
      const response = await automobyApi.post("/container/list", filter)
      setItems(response.data.containers);
      setTotal(response.data.total);
      return response.data.containers
    } catch (error) {
      console.error("თუ ერორია:" + error);
    }
  }

  const searchByBl = async (bl_number, limit = 1) => {
    try {
      const payload = {
        ...defaultConfig,         
        search: bl_number,           
        limit,           
      };
      const response = await automobyApi.post("/container/list", payload);
      return response.data.containers;
    } catch (error) {
      console.error("BL‐search via list failed:", error);
      throw error;
    }
  }


  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 0
      };

      const response = await automobyApi.post("/container/all", requestData) 
      setItems(response.data.containers);
      setTotal(response.data.total);
      return response.data.containers
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const containerCars = async (container_id) => {
    try {
      const requestData = { 
        container_id: container_id, 
      };

      const response = await automobyApi.post("/container/cars", requestData) 
      fetchList();
      return response.data
       
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }


  const countStatuses = async () => {
    try {
      const response = await automobyApi.post("/container/statuses", filter)
      return response.data
    } catch (error) {
      console.error("თუ ერორია:" + error);
    }
  }



  const add = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/container/create`, newData)
        .then(response => {
          fetchList();
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };


    

  const search = async (container, count) => {
    try {
      const requestData = {
        container: container,
        count: count,
      };

      const response = await automobyApi.post("/container/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }


  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/container/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }


  const updateClientPrice = async (newData) => {
    try {
      const response = await automobyApi.post(`/container/update/client/price`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }

  }


  const updateCompanyPrice = async (newData) => {

    try {
      const response = await automobyApi.post(`/container/update/company/price`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }

  }

 


 const listSum = async () => {
    try {
      const response = await automobyApi.post("/container/sum", filter)
      setSum(response.data)
    } catch (error) {
      console.error("თუ ერორია:" + error);
    }
  }




  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          container_id: id
        };
        const response = await automobyApi.post(`/container/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  const distributePrice = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          container_id: id
        };
        const response = await automobyApi.post(`/container/distribute/price`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }


  const updateStatus = async (containerId, statusId) => {
    try {

      const requestData = {
        container_id: containerId,
        status_id: statusId,
      };
      const response = await automobyApi.post("/container/update/status", requestData)

      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === containerId
            ? { ...item, status_id: statusId }
            : item
        )
      ); 
    } catch (error) {
      console.error(error);
    }
  }
 
  const updateLocal = async (container) => {
    setItems(items.map(item =>
      item.id === container.id ? container : item
    ));
  }


const downloadFile = (id, name) => {
  automobyApi({
    url: `/container/image/download`,  
    method: 'POST',
    responseType: 'blob',
    data: { name: name, container_id: id }   
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${id}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  })
  .catch((error) => console.error('Download failed:', error));
};


const downloadCargoFile = (id, name) => {
  automobyApi({
    url: `/cargo/image/download`,  
    method: 'POST',
    responseType: 'blob',
    data: { name: name, cargo_id: id }   
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${id}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  })
  .catch((error) => console.error('Download failed:', error));
};



const downloadDocFile = (id) => {
  automobyApi({
    url: `/container/file/download`,  
    method: 'POST',
    responseType: 'blob',
    data: {  container_id: id }   
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${id}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  })
  .catch((error) => console.error('Download failed:', error));
};

const uploadInvoice = (invoice) => {
  return new Promise((resolve, reject) => {

    automobyApi
      .post("/container/invoice/company/upload/", invoice)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};
  



 
const updateTakenAt = async (newData) => {
  try {
    const response = await automobyApi.post(`/container/update/taken/at`, newData);
    return response.data;
  } catch (error) {
    console.error(error);
  } 
}
 
const updateOpenAt = async (newData) => {
  try {
    const response = await automobyApi.post(`/container/update/open/at`, newData);
    return response.data;
  } catch (error) {
    console.error(error);
  } 
}

const updateEntryAt = async (newData) => {
  try {
    const response = await automobyApi.post(`/container/update/entry/at`, newData);
    return response.data;
  } catch (error) {
    console.error(error);
  } 
}

const updateSendAt = async (newData) => {
  try {
    const response = await automobyApi.post(`/container/update/send/at`, newData);
    return response.data;
  } catch (error) {
    console.error(error);
  } 
}

const downloadReport = (dates) => {
  automobyApi({
    url: `/container/report`,
    method: 'POST',
    responseType: 'blob',
    data: { filter: filter, min: dates.min, max: dates.max }
  })
    .then((response) => {
      const currentDate = new Date();
      const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
      const formattedTime = `${currentDate.getHours()}-${currentDate.getMinutes()}-${currentDate.getSeconds()}`;
      const fileName = `excel_${formattedDate}_${formattedTime}.xlsx`;

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((error) => console.error('Download failed:', error));
};


const downloadExcel = (id, name) => {
  automobyApi({
    url: `/container/excel`,
    method: 'POST',
    responseType: 'blob',
    data: filter
  })
    .then((response) => {
      const currentDate = new Date();
      const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
      const formattedTime = `${currentDate.getHours()}-${currentDate.getMinutes()}-${currentDate.getSeconds()}`;
      const fileName = `excel_${formattedDate}_${formattedTime}.xlsx`;

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((error) => console.error('Download failed:', error));
};


const containerService = {
    items: items,
    total: total,
    filter: filter,
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove,
    updateStatus: updateStatus,
    downloadFile:downloadFile,
    downloadDocFile: downloadDocFile,
    countStatuses: countStatuses,
    distributePrice: distributePrice,
    containerCars: containerCars,
    uploadInvoice:uploadInvoice,
    downloadCargoFile:downloadCargoFile,
    listSum:listSum,
    updateClientPrice:updateClientPrice,
    updateCompanyPrice:updateCompanyPrice, 
    updateTakenAt:updateTakenAt,
    updateOpenAt:updateOpenAt,
    updateEntryAt:updateEntryAt,
    updateSendAt:updateSendAt,
    downloadReport:downloadReport,
    downloadExcel:downloadExcel,
    sum:sum,
    searchByBl: searchByBl
};

  return { containerService };
}